import type { RootState } from '@/store/root-reducer';

const selectEmailChange = (state: RootState) => state.emailChange;

export const selectIsOpen = (state: RootState) => selectEmailChange(state).open;
export const selectDraft = (state: RootState) => selectEmailChange(state).draft;
export const selectSubmitStatus = (state: RootState) => selectEmailChange(state).submitStatus;
export const selectError = (state: RootState) => selectEmailChange(state).error;
export const selectValidationErrors = (state: RootState) =>
  selectEmailChange(state).validationErrors;
export const selectPending = (state: RootState) => selectEmailChange(state).pending;
export const selectLoadStatus = (state: RootState) => selectEmailChange(state).loadStatus;
export const selectIsCancelling = (state: RootState) => selectEmailChange(state).cancelling;

export const selectIsSubmitting = (state: RootState) =>
  selectEmailChange(state).submitStatus === 'submitting';

/**
 * Has the pending state been read at least once? The section renders nothing until
 * it has: showing "Change" for a beat and then swapping it for "a change is pending"
 * would flash the wrong answer at exactly the person who needs the right one.
 *
 * `failed` counts as settled; the section then shows what it last knew rather than
 * hanging on a spinner forever.
 */
export const selectHasLoaded = (state: RootState) =>
  selectEmailChange(state).loadStatus !== 'idle' && selectEmailChange(state).loadStatus !== 'loading';

/**
 * No `selectCanSubmit` here, unlike `password-change.selectors.ts`. Submittability
 * depends on the CURRENT sign-in address (a draft repeating it is invalid), which
 * lives in `AuthContext`, not in this slice; so the section derives it with
 * `isDraftValid(draft, user.email)`. A selector would have to reach outside the
 * store to answer, which is worse than one call in the component.
 */
